// extracted by mini-css-extract-plugin
module.exports = {"container":"user-agreement_container__fZrLA"};